import React from 'react';
import { ShieldOff, ExternalLink } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { getActiveBridge, CHILD_ACTION } from './OptiSignsBridge';

export const EmbedSubscriptionBlockedModal: React.FC = () => {
  const handleGoToBilling = (): void => {
    const bridge = getActiveBridge();
    if (bridge) {
      bridge.sendToParent(CHILD_ACTION.OPEN_BILLING);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-background/80">
      <div className="mx-4 w-full max-w-sm rounded-2xl bg-card p-6 shadow-xl border border-border text-center">
        <div className="mx-auto mb-3 flex h-11 w-11 items-center justify-center rounded-full bg-muted">
          <ShieldOff className="h-5 w-5 text-muted-foreground" />
        </div>
        <h3 className="text-base font-semibold">OptiDev add-on inactive</h3>
        <p className="mt-1.5 text-sm text-muted-foreground">
          Reactivate to continue building.
        </p>
        <p className="mt-3 text-xs text-muted-foreground/60">
          Your existing projects and credits are preserved.
        </p>
        <Button
          onClick={handleGoToBilling}
          className="mt-5 w-full gap-1.5 bg-foreground hover:bg-foreground/90 text-background"
        >
          Reactivate
          <ExternalLink className="h-3.5 w-3.5" />
        </Button>
      </div>
    </div>
  );
};
